export default {
  RESUME: {
    name: 'Resume',
    type: 'Resume',
    id: 'Resume',
    templateId: 'RESUME',
  },
};
